export function getQuoteStatus(status: number) {
  const statusMap: Record<
    number,
    {
      label: string;
      colorScheme: 'gray' | 'yellow' | 'success' | 'error' | 'blue';
    }
  > = {
    1: { label: 'Em digitação', colorScheme: 'gray' },
    2: { label: 'Efetivada', colorScheme: 'success' },
    3: { label: 'Calculada', colorScheme: 'blue' },
    4: { label: 'Deletada no endosso', colorScheme: 'error' },
    6: { label: 'Iniciada', colorScheme: 'gray' },
    7: { label: 'Proposta emitida', colorScheme: 'success' },
    17: { label: 'Cotação em Análise', colorScheme: 'yellow' },
    18: { label: 'Proposta em Análise', colorScheme: 'yellow' },
    99: { label: 'Expirada', colorScheme: 'error' },
    [-9]: { label: 'Deletada', colorScheme: 'gray' },
  };
  return statusMap[status] || { label: 'Desconhecido', colorScheme: 'gray' };
}
